import React, { useState } from 'react';
import './render-news.scss';
import { LabelLink, Label } from '../../../@core-ui';
import ViewNewsModal from '../../../shared/view-news/view-news-modal';
import {
	formatNewsProvider,
	handleEnterKeyPress,
	getAccessToken,
	getDeviceType,
} from '../../../utilities/utils';
import { E_DeviceType } from '../../../constants/appConstants';
interface NewsContentProps {
	newsData?: any[];
	source?: string;
}
const RenderNews: React.FC<NewsContentProps> = (props) => {
	const { newsData, source } = props;
	const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
	const [modalData, setModalData] = useState<any>();
	const isAppContext =
		getDeviceType() === E_DeviceType.Mobile && source === 'app';
	function bindProvider(item: any): React.ReactNode {
		return (
			<React.Fragment>
				<Label isGrey={true} text={`${formatNewsProvider(item.provider)}`} isBold={true} />
				<span className={'dividerProvider'}>|</span>
				<Label isGrey={true} text={`${item.timestamp}`} />
			</React.Fragment>
		);
	}

	function showNewsArticle(item: any) {
		if (isAppContext) {
			const appBaseUrl = window.MD?.WEB_APP_BASE_URL ?? `${window.location.origin}/`;
			const token = window.btoa(getAccessToken());
			const articleId = window.btoa(item.articleId);
			const provider = window.btoa(item.provider ?? '');
			const timeStamp = window.btoa(item.timestamp ?? '');
			window.open(
				`${appBaseUrl}news-article?t=${token}&a=${articleId}&p=${provider}&ts=${timeStamp}`,
				'_blank',
			);
			return;
		}

		setModalData(item);
		setIsModalOpen(true);
		document.body.style.overflowY = 'hidden';
	}

	function hideNewsArticle() {
		setIsModalOpen(false);
		document.body.style.overflowY = 'auto';
	}

	function bindNewsContent(): any {
		return newsData?.map((item: any) => {
			return (
				<div
					className={'news-content'}
					key={`news ${item.articleId}`}
					onClick={() => showNewsArticle(item)}
					onKeyDown={(e) => handleEnterKeyPress(e, () => showNewsArticle(item))}
				>
					<div className="headline">
						<LabelLink text={item.headline} dataKey={item.articleId} />
					</div>
					<div className="provider">{bindProvider(item)}</div>
				</div>
			);
		});
	}

	return (
		<div
			className="news-content-container"
			data-testid="news-content-container"
		>
			{bindNewsContent()}
			{isModalOpen && (
				<ViewNewsModal
					articleId={modalData?.articleId}
					provider={modalData?.provider}
					timeStamp={modalData?.timestamp}
					onClose={hideNewsArticle}
				/>
			)}
		</div>
	);
};

export default RenderNews;
